import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { usePopup } from '../../context/PopupContext';

const WaitingPopup = (props) => {
    const { boxContent, close, status, rightCallbackAction, leftCallbackAction, data, waiting, setWaiting } = usePopup();
    const [waitingTxt, setWaitingTxt] = useState();

    // useEffect(() => {
    //     if(typeof data != 'undefined'){
    //         let downloadFormat = (data.plan == 'pro' ? props.downloadFormat : 'text'); 
    //         dispatch(setResumeFormat(downloadFormat));
    //         setActiveFormat(downloadFormat);
    //     }
    // }, [data]);

    // Array for static text which is showing on downloading popup.

    useEffect(() => {
        setWaitingTxt(props.waitingTxt);
    })

    // Preparing text after open the popup for download
    // console.log(activeFormat);

    return (<>
        {status('waitingbox') && <><div className="transparent-popup-bg"></div>
            <div className="custom-skip-popup">

                {/* <div className="close-btn-icon">
                     <button className="close-icon"
                        onClick={() => {
                            removeLocalItems();
                            dispatch(setResumeFormat('pdf'));
                            close();
                        }}>Close</button> 
                </div> */}
                <div className="content-box">
                    <h4>{waitingTxt}</h4>
                    {/* <p style={{marginBottom: '10px'}}>{getResumeName()}</p> */}
                    <>
                    <div style={{marginBottom: '10px'}}>
                        <img src="/assets/images/animated-sandbox.gif" alt="download" width="100" />
                    </div>
                    <div id="foo" className="copy-label center" style={{ height: '25px', width: '291px' }}>{boxContent.content ?? 'Waiting'}</div>
                    </>
                        
                </div>
            </div></>}
    </>)
}
export default connect(state => state)(WaitingPopup);

